module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('v-autocomplete', {
    staticClass: "mt-1 rounded-lg",
    attrs: {
      "height": "48px",
      "filled": "",
      "dense": "",
      "rounded": "",
      "clearable": "",
      "append-icon": "search",
      "hide-details": "",
      "placeholder": 'Kontakte suchen',
      "items": _vm.selectBundesbruder
    },
    on: {
      "change": function($event) {
        return _vm.selectBbr()
      }
    },
    model: {
      value: (_vm.bundesbruder),
      callback: function($$v) {
        _vm.bundesbruder = $$v
      },
      expression: "bundesbruder"
    }
  }), _vm._v(" "), (_vm.bundesbruder) ? _c('div', [_c('dialogKontakt', {
    attrs: {
      "visible": _vm.showBbr,
      "bbr": _vm.bbr
    },
    on: {
      "update:visible": function($event) {
        _vm.showBbr = $event
      },
      "close": function($event) {
        _vm.showBbr = false
      }
    }
  })], 1) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-370e591e"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/module_klein/bundesbruderSucheShort.vue
// module id = 757
// module chunks = 15